import { render } from "./RegisterProfile.vue?vue&type=template&id=9dd09f8a"
import script from "./RegisterProfile.vue?vue&type=script&lang=js"
export * from "./RegisterProfile.vue?vue&type=script&lang=js"

import "./RegisterProfile.vue?vue&type=style&index=0&id=9dd09f8a&lang=css"

import exportComponent from "C:\\Users\\pawarawat\\Documents\\Vue\\WebServer_Vue_NameCardSouvenir\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__